<template>
  <!-- ************************************************** --
    -- 配車複写ダイアログ
    -- ************************************************** -->
  <!-- 受注チップ -->
  <v-dialog v-model="showDialog" width="800" max-width="90%" style="z-index:500" persistent no-click-animation>
    <v-card>
      <v-toolbar elevation="1" color="#6091d3" dark dense>
        <v-spacer></v-spacer>
        <v-toolbar-title>配車複写</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn @click="onClickCopyClose" text><v-icon>mdi-close</v-icon></v-btn>
      </v-toolbar>
      <v-card-text>
        <v-container>
          <v-row no-gutters align-content="center" class="my-1">
            <div class="px-1" style="font-weight:bold;color:navy">指定された配車年月日の営業所の計画を複写します</div>
          </v-row>
          <v-row no-gutters align-content="center" class="my-1">
            <v-col :cols="5" class="px-5">
              <dd-date-box
              label="複写元配車年月日"
              v-model="copyConditions.haishaYmdFrom"
              ref="refHaishaYmdFrom"
              :required="true"
              />
            </v-col>
            <v-col :cols="2" class="mt-1">
              <v-row no-gutters justify="center">
                <v-col>
                  <v-icon>mdi-chevron-triple-right</v-icon>
                  <v-icon>mdi-chevron-triple-right</v-icon>
                  <v-icon>mdi-chevron-triple-right</v-icon>
                  <v-icon>mdi-chevron-triple-right</v-icon>
                  <v-icon>mdi-chevron-triple-right</v-icon>
                </v-col>
               </v-row>
            </v-col>
            <v-col :cols="5" class="px-5">
              <dd-date-box
              label="複写先配車年月日"
              v-model="copyConditions.haishaYmdTo"
              ref="refHaishaYmdTo"
              :required="true"
              />
            </v-col>
          </v-row>
          <v-row no-gutters align-content="center" class="my-1">
            <v-col :cols="5" class="px-5">
              <dd-drop-down
                v-model="haishahyoCd"
                ref="haishahyoCdDisp"
                label="営業所"
                placeholder="選択してください"
                :items="filteredHaishaHyoList"
                :required="true"
                :readonly="true"
                />
            </v-col>
          </v-row>
          <v-row no-gutters align-content="center" class="my-1">
            <v-col :cols="5" class="px-5">
              <dd-checkbox v-model="copyConditions.jomuinCopyFlg" label="乗務員を複写する"/>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-btn elevation="2" class="mx-5" text outlined rounded dark style="background:#2F75B5;" min-width="100" @click="onClickCopyClose">閉じる</v-btn>
        <v-spacer></v-spacer>
        <v-btn elevation="2" class="mx-5" text outlined rounded dark style="background:#2F75B5;" min-width="100" @click="onClickCopyExec">実行</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
// ----- <ここからJavaScript> ------------------------------------------------------------------------------------------------------------------------
//
//
// ************************************************************************************************************************
// <特記事項>
//  mapGetters用のLoadMaster(menuList等の取得)は当コンポーネントを呼び出す画面で実施する事
// ************************************************************************************************************************
//
//
//
// Rahmen Definition アルファベット順記述
import controls from '@/rahmen/controls'
import dayjs from 'dayjs'
import flowMixin from '@/mixins/flowMixins'
import modals from '@/ddv2.library/modals'

// vue Definition
import { mapGetters } from 'vuex'

// DdComponents アルファベット順記述
const DdCheckbox = () => import('@/components/DdCheckbox')
const DdDateBox = () => import('@/components/DdDateBox')
const DdDropDown = () => import('@/components/DdDropDown')

export default {
  name: 'DdHaishaCopyDialog',
  mixins: [flowMixin],

  // 参照コンポーネント定義
  components: {
    DdCheckbox,
    DdDateBox,
    DdDropDown
  },

  // プロパティ定義
  props: {
    /**
     * 表示状態
     */
    showDialog: Boolean,
    param: {
      haishaYmdFrom: '',
      mstHaishaHyoId: '',
      startHM: ''
    }
  },

  data: () => ({
    invalidMessage: '',

    // 乗務員フィルター初期値
    copyConditions: {
      haishaYmdFrom: '',
      haishaYmdTo: '',
      mstHaishaHyoId: '',
      startHM: '',
      jomuinCopyFlg: '',
      juchuCopyFlg: true
    },
    haishahyoCd: '',

    // 戻り値用定義
    rec: {
      id: 0
    }
  }),

  created () {
  },

  watch: {
    showDialog: function () {
      if (this.showDialog === true) {
        // ここに表示時やりたいこと書く
        this.copyConditions.haishaYmdFrom = this.param.fromHaishaYmd
        this.haishahyoCd = this.param.mstHaishaHyoId
        this.copyConditions.startHM = this.param.startHM
        this.copyConditions.jomuinCopyFlg = true
        this.copyConditions.juchuCopyFlg = true
      }
    }
  },

  mounted () {
    const dtl = controls.getInputTypeDetail(this.valueType)
    if (!dtl) { return }
    this.invalidMessage = this.errorMessages
    console.log('mounted', this.invalidMessage, this.$el)

    this.initBindVariables()
  },

  /* **************************************************************************************************** *
   *
   * 算出プロパティ
   *
   * **************************************************************************************************** */
  computed: {
    // --------------------------------------------------------------------------------
    // Indexed DB データ
    // --------------------------------------------------------------------------------
    ...mapGetters({
      haishahyoList: 'DDMasters/mstHaishahyo'
    }),

    // --------------------------------------------------------------------------------
    // フィルター
    // --------------------------------------------------------------------------------
    // 配車表フィルター
    filteredHaishaHyoList () {
      var defArray = [{ value: null, text: '未選択' }]
      const resultArray = this.haishahyoList.map(elem => {
        return {
          value: elem.haishahyoCd,
          text: `${elem.haishahyoCd}:${elem.haishahyoNm}`
        }
      })
      return defArray.concat(resultArray)
    }
  },

  /* **************************************************************************************************** *
   *
   * メソッド
   *
   * **************************************************************************************************** */
  methods: {
    initialize: function () {
      // const self = this
      const opt = {
        loadMasters: [],
        settingLoadEffect: function () {
          return true
        }
      }
      this.initializeForViewer(opt)
    },
    // --------------------------------------------------------------------------------
    // 初期値設定
    // --------------------------------------------------------------------------------
    initBindVariables: function () {
    },
    // --------------------------------------------------------------------------------
    // 閉じるボタン押下
    // --------------------------------------------------------------------------------
    onClickCopyClose: function (e) {
      this.$emit('close', undefined)
    },
    onClickCopyExec: function (e) {
      this.onCopyAction()
      console.log(e)
    },
    onCopyAction: function () {
      const self = this
      const opt = {
        registerRequestPromise: self.registerPromise,
        registerResponsePromise: (data) => {
          return new Promise(resolve => {
            var rex = data.payload
            if (rex !== '') {
              modals.showError(rex)
            } else {
              modals.showSuccess(this.copyConditions.haishaYmdFrom + 'から' + this.copyConditions.haishaYmdTo + 'の配車計画を作成しました')
              this.$emit('exec', undefined)
            }
            resolve()
          })
        },
        getIdMethod: () => {
          return 0
        },
        continuousInputInitializePromise: (id) => {
          return new Promise(resolve => {
            resolve()
          })
        },
        getTransitionBackParams: function () {
          return {
            actionId: 0,
            param: { id: self.id }
          }
        },
        isUpdateModeMethod: function () {
          return true
        },
        isNoRefreshModeMethod: function () {
          return true
        },
        isNoMessageModeMethod: function () {
          return true
        }
      }
      this.register(opt)
    },
    registerPromise: function () {
      // /* eslint no-debugger: "warn" */
      // debugger
      this.copyConditions.mstHaishaHyoId = this.convertHaishahyoCdtoId(this.haishahyoCd)
      const f = this.HttpClient.post('/api/v1/D2Plmd0010/CopyHaishahyo', this.copyConditions)
      return f
    },
    registerValidate: function () {
      // 複写先日付チェック※同日不可
      const l = dayjs(this.copyConditions.haishaYmdFrom, 'YYYY/MM/DD', true).unix()
      const b = dayjs(this.copyConditions.haishaYmdTo, 'YYYY/MM/DD', true).unix()
      if (l >= b) {
        this.$refs.refHaishaYmdTo[this.Ctrls.SET_INVALID_METHOD]('複写先配車年月日には複写元年月日より未来の日付を指定して下さい')
        return false
      }

      return true
    },
    // 配車表ID変換
    convertHaishahyoCdtoId (val) {
      var d = this.haishahyoList.filter((t) => {
        return t.haishahyoCd === val
      })
      if (d.length > 0) {
        return d[0].id
      } else {
        return 0
      }
    }
  }
}
</script>
<style></style>
